import { Protection } from '@sky-uk-ott/client-lib-js-device';
import { AdInsertionType } from '../../addons/ad-insertion-type';
import { AdInsertionStrategy, DrmType } from './player.enums';
export { AdInsertionStrategy, AdsFailoverReason, DrmType, DvrWindowDuration, MediaContainer, PlaybackType, Source, StreamQuality, StreamVendor, StreamingProtocol, PlayoutDataError, PlayerDrmError, DownloadState, DrmProvider, MultiviewParallelAudioTracks } from './player.enums';
/**
 * @internal Playout attributes needed for the player to actually playing
 *         Stream parameters needed to play the actual stream
 */ /**
 * @internal Needed DRM protection attributes
 *
 */ /**
 * @public
 */ export function protectionToDrmType(protection) {
    switch(protection){
        case Protection.Fairplay:
            return DrmType.Fairplay;
        case Protection.PlayReady:
            return DrmType.PlayReady;
        case Protection.Widevine:
            return DrmType.Widevine;
        case Protection.Marlin:
            return DrmType.Marlin;
    }
}
/**
 * @internal Support for HTML element to wrap the video element
 *         and also supports adding a css class name to it
 *
 */ /**
 * @internal Supports setting visual properties to the native player, either with exact
 *         pixel measurements or by specifying a percentage of the player size
 */ /**
 * @internal Adaptative bit rate (audio + video) configuration
 *         Unit: Bits per Second (b/s)
 */ /**
 * @public
 */ // what clients used to sent before as a string
// optional - Boolean on whether the language has audio description (AD) or not
// what clients used to sent before as a string
/**
 * @internal Playout attributes needed for the player to actually play and render the stream's video
 *
 */ // DISCUSS: We should review if we need all this attributes
//           e.g. at this time we maybe only need 1 cdn, the selection
//                should be made before at a session level
// DISCUSS: Should we have support for multiple streaming protocols?
// Some web players can play different types of streaming protocols
// (e.g. Shaka Player can play HLS and DASH)
// DISCUSS: muted, volume, position, audioLanguage, textLanguage
//          should this (maybe) be inside a structure called "initialPlayerState" (or something similar)
// Used for VPF Retry to indicate information about a specific track (e.g. English+Surround vs English+Stereo)
// Used for VPF Retry to indicate information about a specific track (e.g. English+CEA vs English+WebVTT)
// DISCUSS: Need for this custom field
// TODO: discuss the following attribute, it appears as it is not being used at all
// Having Conviva custom tags in the base of 'PlayoutData' isn't great
// We should create a new field `AddonPlayoutData.Conviva` or something similar
export function isMultiplayerCsai(playoutData) {
    var adInsertionConfig = playoutData.adInsertionConfig;
    return (adInsertionConfig === null || adInsertionConfig === void 0 ? void 0 : adInsertionConfig.adInsertionStrategy) === AdInsertionStrategy.CSAI && adInsertionConfig.adProvider === AdInsertionType.MultiPlayerCsai;
}
export function isSleCsai(playoutData) {
    var _playoutData_advertising_vac, _playoutData_advertising;
    return !!((_playoutData_advertising = playoutData.advertising) === null || _playoutData_advertising === void 0 ? void 0 : (_playoutData_advertising_vac = _playoutData_advertising.vac) === null || _playoutData_advertising_vac === void 0 ? void 0 : _playoutData_advertising_vac.sleCsai);
} /**
 * @public
 */ 

//# sourceMappingURL=playout-data.js.map